// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.stage-selector_stage-selector_fsJ9W {
    background-clip: padding-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative; /* For the add backdrop button */
    flex-grow: 1;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: var(--ui-white);
    color: var(--text-primary);
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-color: var(--ui-black-transparent);
    border-width: 1px;
    border-style: solid;
    border-bottom: 0;
    cursor: pointer;
    transition: all 0.25s ease;
}

.stage-selector_stage-selector_fsJ9W.stage-selector_is-selected_Lz2kQ {
    border-top-left-radius: .625rem;
    border-top-right-radius: .625rem;
    border-color: var(--looks-secondary);
    box-shadow: 0px 0px 0px 4px var(--looks-transparent);
}

.stage-selector_stage-selector_fsJ9W:hover {
    border-color: var(--looks-secondary);
}

.stage-selector_header_FIlev {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(2.75rem - 2px);
    background-color: var(--ui-white);
    color: var(--text-primary);
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-bottom: 1px solid var(--ui-black-transparent);
    width: 100%;
    transition: background-color 0.25s ease;
}

.stage-selector_header-title_t9UhC {
    font-size: 0.625rem;
    font-weight: bold;
    color: var(--text-primary);

    /* @todo: make this a mixin for all UI text labels */
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    transition: color 0.25s ease;
}

.stage-selector_stage-selector_fsJ9W.stage-selector_is-selected_Lz2kQ .stage-selector_header_FIlev {
    background-color: var(--looks-secondary);
}

.stage-selector_stage-selector_fsJ9W.stage-selector_is-selected_Lz2kQ .stage-selector_header-title_t9UhC {
    color: #ffffff;
}

.stage-selector_count_FUO9X {
    padding: 0.3rem 0.75rem;
    font-size: 0.625rem;
    color: var(--text-primary);
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.stage-selector_label_YEx5s {
    margin: 0.75rem 0 0.25rem;
    font-size: 0.6rem;
    color: var(--text-primary);
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    text-align: center;
}

.stage-selector_costume-canvas_cRPnz {
    display: block;
    margin-top: .25rem;
    width: 100%;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    border: 1px solid var(--ui-black-transparent);
    border-radius: .25rem;
    box-shadow: inset 0 0 4px var(--shadow);
    max-width: 64px;
    max-height: 48px;
}

.stage-selector_add-button_m4M4a {
    position: absolute;
    bottom: 0.75rem;
}

.stage-selector_raised_CRDyr, .stage-selector_raised_CRDyr .stage-selector_header_FIlev {
    background-color: var(--drop-highlight);
    transition: all 0.25s ease;
}

.stage-selector_raised_CRDyr:hover {
    transform: scale(1.05);
}

.stage-selector_receivedBlocks_nZtOI {
    animation: stage-selector_glowing_Q6XYo 250ms;
}

@keyframes stage-selector_glowing_Q6XYo {
    10% { box-shadow: 0 0 10px #7fff1e; }
    90% { box-shadow: 0 0 10px #7fff1e; }
    100% { box-shadow: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/stage-selector/stage-selector.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB,EAAE,gCAAgC;IACpD,YAAY;IACZ,2DAA2D;IAC3D,iCAAiC;IACjC,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;IAC/B,yCAAyC;IACzC,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,oCAAoC;IACpC,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;IAC/B,oDAAoD;IACpD,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;;IAE1B,oDAAoD;IACpD,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,4BAA4B;AAChC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,0BAA0B;IAC1B,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,6CAA6C;IAC7C,qBAAqB;IACrB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6CAAwB;AAC5B;;AAEA;IACI,MAAM,4BAA4B,EAAE;IACpC,MAAM,4BAA4B,EAAE;IACpC,OAAO,gBAAgB,EAAE;AAC7B","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.stage-selector {\n    background-clip: padding-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative; /* For the add backdrop button */\n    flex-grow: 1;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background-color: var(--ui-white);\n    color: var(--text-primary);\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n    border-color: var(--ui-black-transparent);\n    border-width: 1px;\n    border-style: solid;\n    border-bottom: 0;\n    cursor: pointer;\n    transition: all 0.25s ease;\n}\n\n.stage-selector.is-selected {\n    border-top-left-radius: .625rem;\n    border-top-right-radius: .625rem;\n    border-color: var(--looks-secondary);\n    box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n}\n\n.stage-selector:hover {\n    border-color: var(--looks-secondary);\n}\n\n.header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: calc(2.75rem - 2px);\n    background-color: var(--ui-white);\n    color: var(--text-primary);\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n    border-bottom: 1px solid var(--ui-black-transparent);\n    width: 100%;\n    transition: background-color 0.25s ease;\n}\n\n.header-title {\n    font-size: 0.625rem;\n    font-weight: bold;\n    color: var(--text-primary);\n\n    /* @todo: make this a mixin for all UI text labels */\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    transition: color 0.25s ease;\n}\n\n.stage-selector.is-selected .header {\n    background-color: var(--looks-secondary);\n}\n\n.stage-selector.is-selected .header-title {\n    color: #ffffff;\n}\n\n.count {\n    padding: 0.3rem 0.75rem;\n    font-size: 0.625rem;\n    color: var(--text-primary);\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.label {\n    margin: 0.75rem 0 0.25rem;\n    font-size: 0.6rem;\n    color: var(--text-primary);\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    text-align: center;\n}\n\n.costume-canvas {\n    display: block;\n    margin-top: .25rem;\n    width: 100%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: .25rem;\n    box-shadow: inset 0 0 4px var(--shadow);\n    max-width: 64px;\n    max-height: 48px;\n}\n\n.add-button {\n    position: absolute;\n    bottom: 0.75rem;\n}\n\n.raised, .raised .header {\n    background-color: var(--drop-highlight);\n    transition: all 0.25s ease;\n}\n\n.raised:hover {\n    transform: scale(1.05);\n}\n\n.receivedBlocks {\n    animation: glowing 250ms;\n}\n\n@keyframes glowing {\n    10% { box-shadow: 0 0 10px #7fff1e; }\n    90% { box-shadow: 0 0 10px #7fff1e; }\n    100% { box-shadow: none; }\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `stage-selector_stage-selector_fsJ9W`;
export { _1 as "stage-selector" };
export var stageSelector = `stage-selector_stage-selector_fsJ9W`;
var _2 = `stage-selector_is-selected_Lz2kQ`;
export { _2 as "is-selected" };
export var isSelected = `stage-selector_is-selected_Lz2kQ`;
export var header = `stage-selector_header_FIlev`;
var _3 = `stage-selector_header-title_t9UhC`;
export { _3 as "header-title" };
export var headerTitle = `stage-selector_header-title_t9UhC`;
export var count = `stage-selector_count_FUO9X`;
export var label = `stage-selector_label_YEx5s`;
var _4 = `stage-selector_costume-canvas_cRPnz`;
export { _4 as "costume-canvas" };
export var costumeCanvas = `stage-selector_costume-canvas_cRPnz`;
var _5 = `stage-selector_add-button_m4M4a`;
export { _5 as "add-button" };
export var addButton = `stage-selector_add-button_m4M4a`;
export var raised = `stage-selector_raised_CRDyr`;
export var receivedBlocks = `stage-selector_receivedBlocks_nZtOI`;
export var glowing = `stage-selector_glowing_Q6XYo`;
export default ___CSS_LOADER_EXPORT___;
